import { Edit, Plus } from "lucide-react";
import React, { useState } from "react";
import AccountInfoClient from "../../components/clients/AccountInfoClient";
import accountApi from "../../api/accountApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import BusinessInfoClient from "../../components/clients/BusinessInfoClient";
import businesInformationApi from "../../api/businesInformationApi";
import { Button } from "../../components/Button";
import { FaBusinessTime } from "react-icons/fa";
import { REGEX } from "../../utils/regex";

const formatText = (text = "") =>
  text
    ?.toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const OverviewTab = ({ selectedClientData, onRefreshAccounts }) => {
  console.log("selectedClientData====>", selectedClientData);
  const token = useSelector((state) => state.auth.access_token);
  const [isUpdateBasic, setIsUpdateBasic] = useState(null);
  const [isUpdateBusness, setIsUpdateBusness] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [errors, setErrors] = useState({});
  const [errors2, setErrors2] = useState({});

  const safeTrim = (value) => (value || "").trim();

  const validateForm = () => {
    const newErrors = {};

    if (!safeTrim(isUpdateBasic.accountOwner))
      newErrors.accountOwner = "Account Owner is required";

    if (!safeTrim(isUpdateBasic.accountName))
      newErrors.accountName = "Account Name is required";

    if (!safeTrim(isUpdateBasic.email)) {
      newErrors.email = "Email is required";
    } else if (!REGEX.EMAIL.test(safeTrim(isUpdateBasic.email))) {
      newErrors.email = "Enter a valid email address";
    }

    if (!safeTrim(isUpdateBasic.panNumber)) {
      newErrors.panNumber = "PAN Number is required";
    } else if (
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(safeTrim(isUpdateBasic.panNumber))
    ) {
      newErrors.panNumber = "Enter a valid PAN Number (e.g., ABCDE1234F)";
    }

    if (!safeTrim(isUpdateBasic.website)) {
      newErrors.website = "Website is required";
    } else if (
      safeTrim(isUpdateBasic.website).includes(" ") ||
      !REGEX.WEBSITE.test(safeTrim(isUpdateBasic.website))
    ) {
      newErrors.website =
        "Website must be a valid domain and must not contain spaces";
    }

    if (!safeTrim(isUpdateBasic.fax)) newErrors.fax = "Fax is required";

    if (!isUpdateBasic.industry) newErrors.industry = "Industry is required";

    if (!isUpdateBasic.companyType)
      newErrors.companyType = "Company Type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateForm2 = () => {
    const newErrors = {};

    if (!safeTrim(isUpdateBusness.businessType))
      newErrors.businessType = "Business Type is required";

    if (!safeTrim(isUpdateBusness.company))
      newErrors.company = "Company is required";

    if (!isUpdateBusness.annualRevenue)
      newErrors.annualRevenue = "Annual Revenue is required";

    setErrors2(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handelUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill all required fields correctly.");
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      await accountApi.updateAccount(
        selectedClientData?.id,
        isUpdateBasic,
        token,
      );
      setIsUpdateBasic(null);
      toast.success("Account Information Update Successfully!");
      onRefreshAccounts();
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching account:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handelUpdateBusness = async (e) => {
    e.preventDefault();
    if (!validateForm2()) {
      toast.error("Please fill all required fields correctly.");
      setIsLoading2(false);
      return;
    }
    try {
      setIsLoading2(true);
      if (selectedClientData?.businessInformation === null) {
        await businesInformationApi.createBusinesInformation(
          selectedClientData?.id,
          isUpdateBusness,
          token,
        );
        setIsUpdateBusness(null);
        toast.success("Busness Information Create Successfully!");
        onRefreshAccounts();
        setIsLoading2(false);
      } else {
        await businesInformationApi.updateBusinesInformation(
          selectedClientData?.id,
          isUpdateBusness,
          token,
        );
        setIsUpdateBusness(null);
        toast.success("Busness Information Update Successfully!");
        onRefreshAccounts();
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching account:", error);
      setIsLoading2(false);
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="relative bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-3">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Account Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {selectedClientData?.accountOwner ? (
            <InfoRow
              label="Contact Person"
              value={selectedClientData?.accountOwner}
            />
          ) : (
            <></>
          )}
          {selectedClientData?.accountName ? (
            <InfoRow
              label="Account Name"
              value={selectedClientData?.accountName}
            />
          ) : (
            <></>
          )}
          {selectedClientData?.email ? (
            <InfoRow label="Email" value={selectedClientData?.email} />
          ) : (
            <></>
          )}
          {selectedClientData?.fax ? (
            <InfoRow label="Fax" value={selectedClientData?.fax} />
          ) : (
            <></>
          )}
          {selectedClientData?.mobileNumber ? (
            <InfoRow
              label="Mobile Number"
              value={selectedClientData?.mobileNumber}
            />
          ) : (
            <></>
          )}
          {selectedClientData?.phoneNumber ? (
            <InfoRow
              label="Phone Number"
              value={selectedClientData?.phoneNumber}
            />
          ) : (
            <></>
          )}
          {selectedClientData?.website ? (
            <InfoRow label="Website" value={selectedClientData?.website} />
          ) : (
            <></>
          )}
          {selectedClientData?.leadSource ? (
            <InfoRow
              label="Lead Source"
              value={selectedClientData?.leadSource}
            />
          ) : (
            <></>
          )}
          {selectedClientData?.industry ? (
            <InfoRow label="Industry" value={selectedClientData?.industry} />
          ) : (
            <></>
          )}
          {selectedClientData?.panNumber ? (
            <InfoRow label="PAN Number" value={selectedClientData?.panNumber} />
          ) : (
            <></>
          )}
          {selectedClientData?.companyType ? (
            <InfoRow
              label="Company Type"
              value={formatText(selectedClientData?.companyType)}
            />
          ) : (
            <></>
          )}
          <div
            className={`absolute top-2 right-2 ${selectedClientData?.companyTyp !== null ? "" : "md:col-span-2"}`}
          >
            <button
              onClick={() =>
                setIsUpdateBasic({
                  accountOwner: selectedClientData?.accountOwner ?? "",
                  accountName: selectedClientData?.accountName ?? "",
                  email: selectedClientData?.email ?? "",
                  fax: selectedClientData?.fax ?? "",
                  mobileNumber: selectedClientData?.mobileNumber ?? "",
                  phoneNumber: selectedClientData?.phoneNumber ?? "",
                  website: selectedClientData?.website ?? "",
                  leadSource: selectedClientData?.leadSource ?? "",
                  industry: selectedClientData?.industry ?? "",
                  panNumber: selectedClientData?.panNumber ?? "",
                  companyType: selectedClientData?.companyType ?? "",
                })
              }
              className="text-blue-600"
            >
              <Edit size={16} />
            </button>
          </div>
        </div>
      </div>

      <div className="relative bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-3">
        {selectedClientData?.businessInformation === null ? (
          <div className="h-full">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Business Information
              </h3>
              <button
                type="button"
                onClick={() =>
                  setIsUpdateBusness({
                    businessType:
                      selectedClientData?.businessInformation?.businessType ??
                      "",
                    company:
                      selectedClientData?.businessInformation?.company ?? "",
                    annualRevenue:
                      selectedClientData?.businessInformation?.annualRevenue ??
                      "",
                    id: selectedClientData?.businessInformation?.id ?? "",
                  })
                }
                className="bg-primary text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
              >
                <Plus className="h-4 w-4" />
                <span>Business Information</span>
              </button>
            </div>
            <div className="bg-white rounded-lg mt-[15%] shadow-sm border border-gray-200 p-6 text-center">
              <FaBusinessTime className="h-12 w-12 text-gray-500 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No Business Information
              </h3>
              <p className="text-gray-600 mb-4">
                This client doesn't have any Business Information yet.
              </p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="md:col-span-2">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Business Information
              </h3>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Business Type
              </label>
              <p className="text-sm text-gray-900">
                {formatText(
                  selectedClientData?.businessInformation?.businessType,
                ) || "___"}{" "}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Company Name
              </label>
              <p className="text-sm text-gray-900">
                {selectedClientData?.businessInformation?.company || "___"}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Annual Revenue
              </label>
              <p className="text-sm text-gray-900">
                ₹{selectedClientData?.businessInformation?.annualRevenue || 0}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                GST Registrations
              </label>
              <p className="text-sm text-gray-900">
                {
                  selectedClientData?.businessInformation?.gstRegistrations
                    ?.length
                }{" "}
                Active
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Locations
              </label>
              <p className="text-sm text-gray-900">
                {selectedClientData?.businessInformation?.locations?.length ||
                  0}{" "}
                Locations
              </p>
            </div>
            <div className="absolute top-2 right-2">
              <button
                onClick={() =>
                  setIsUpdateBusness({
                    businessType:
                      selectedClientData?.businessInformation?.businessType ??
                      "",
                    company:
                      selectedClientData?.businessInformation?.company ?? "",
                    annualRevenue:
                      selectedClientData?.businessInformation?.annualRevenue ??
                      "",
                    id: selectedClientData?.businessInformation?.id ?? "",
                  })
                }
                className="text-blue-600"
              >
                <Edit size={16} />
              </button>
            </div>
          </div>
        )}
      </div>

      {isUpdateBasic !== null && (
        <div
          onClick={() => setIsUpdateBasic(null)}
          className="fixed inset-0 bg-black/40 flex items-center justify-center"
        >
          <AccountInfoClient
            handelUpdate={handelUpdate}
            isLoading={isLoading}
            errors={errors}
            formData={isUpdateBasic}
            setFormData={setIsUpdateBasic}
          />
        </div>
      )}
      {isUpdateBusness !== null && (
        <div
          onClick={() => setIsUpdateBusness(null)}
          className="fixed inset-0 bg-black/40 flex items-center justify-center"
        >
          <BusinessInfoClient
            handelUpdate={handelUpdateBusness}
            isLoading={isLoading2}
            errors={errors}
            formData={isUpdateBusness}
            setFormData={setIsUpdateBusness}
          />
        </div>
      )}
    </div>
  );
};

export default OverviewTab;

const InfoRow = ({ label, value }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <p className="text-sm text-gray-900 break-all">{value || "-"}</p>
  </div>
);
